// Default configuration for the integrated SuperTrend trading system.
// MultiPaneChart merges the caller-supplied superTrendConfig prop over these.

export const DEFAULT_SUPERTREND_CONFIG = {
  // SuperTrend Settings
  atrPeriod: 10,
  multiplier: 3.0,
  changeATR: true,
  source: 'hl2',

  // Display Settings
  showSignals: true,
  showStrong: true,
  highlighting: true,
  showTP: false,
  showSL: false,
  showDashboard: true,

  // Market Structure Filters
  useMarketStructure: false,
  emaFast: 20,
  emaSlow: 50,
  emaBaseline: 200,

  // Momentum Filters
  rsiLen: 14,
  rsiBull: 55,
  rsiBear: 45,
  rsiOverbought: 70,
  rsiOversold: 30,
  macdFast: 12,
  macdSlow: 26,
  macdSignal: 9,

  // Trend Strength Filters
  adxLen: 14,
  adxThresh: 25,
  adxStrong: 40,
  atrVolatility: true,
  atrVolLen: 14,
  atrVolThresh: 1.5,

  // Volume Analysis
  useVolume: true,
  volLen: 20,
  volMultiplier: 1.5,
  useVWAP: true,

  // Signal Strength Settings
  minConfirm: 3,
  minStrongConfirm: 5,

  // Risk Management
  atrPeriodMain: 14,
  stopType: 'ATR Trailing',
  atrStopMult: 2.0,
  tp1AtrMult: 1.5,
  tp2AtrMult: 3.0,
  tp3AtrMult: 4.5,

  // Dynamic TP System
  enableDynamicTP: true,
  dynamicTPMode: 'Replace Static',
  tp1_mult: 1.0,
  tp2_mult: 1.5,
  tp3_mult: 2.0,
  tp1_period: 7,
  tp2_period: 10,
  tp3_period: 14,

  // TP Settings
  useStructureTP: true,
  tpEmaFast: 9,
  tpEmaSlow: 21,
  useMomentumTP: true,
  tpRsiPeriod: 14,
  tpRsiOverbought: 75,
  tpRsiOversold: 25,
  useSRTP: true,
  srLookbackTP: 20,

  // Profit Protection
  minProfitPct: 0.5,
  partialTP1: 33,
  partialTP2: 50,
  partialTP3: 100,

  // Anti-Overlap Protection
  enableAntiOverlap: true,
  tpCooldownBars: 3,
  minTrendStability: 2,
  whipsawThreshold: 3,
  dynamicMinProfit: 1.0,
};
